export default __webpack_public_path__ + "static/media/logo_Ethics.e37498bb.svg";